import CookiesPanel from './CookiesPanel';

export default CookiesPanel;
